export default __webpack_public_path__ + "60f6af5f9f0a263ebe076f58b3c697bc.png";